import "./AiTextButton.scss";

export const AiTextButton = ({ Icon, title, onClick }) => {
    return (
        <button className="ai_text_button" onClick={onClick}>
            <span className="ai_text_button_border" />

            <span className="ai_text_button_content">
                {Icon && <Icon className="ai_text_button_icon" ы />}
                {title}
            </span>
        </button>
    );
};